<template>
  <div id="app" >
    <Header v-on:changePage="setNextPage" />
     <div class="content">
    <b-container class="mt-4">
    <Dispatcher v-if="appReady" :current="component" v-on:changePage="setNextPage" />
    <!-- spinner -->
    <div v-if="spinner" class="text-center pt-2">
      <b-spinner style="width: 3rem; height: 3rem;" variant="success" label="Spinning" disabled="labelStatus"></b-spinner>
    </div>
    </b-container>
    </div>
    <Footer />
  </div>
</template>

<script>
import axios from 'axios';
import Header from './components/Header.vue'
import Footer from './components/Footer.vue'
import Dispatcher from './components/Dispatcher.vue'

export default {  
  name: 'app',
  data: () => ({
    acceptedPropertyCode: ['1160R', '4530'],
    error: "",
    component: "Login",
    pageStack: [],
    spinner: false,
    appReady: false
  }),
  mounted () {
    if (/*@cc_on!@*/false || !!document.documentMode) {
      this.error = this.$i18n.locale === "fr" ? "INTERNET EXPLORER N'EST PAS SUPPORTÉ. VEUILLEZ UTILISER CHROME, FIREFOX OU MICROSOFT EDGE"
      : "INTERNET EXPLORER IS NOT SUPPORTED. PLEASE USE CHROME, FIREFOX OR MICROSOFT EDGE";
    }
    else {
      this.setLanguage();
      this.getQueryString();
    }
  },
  computed: {
    url: function () {
      let urls = this.$store.getters.getUrlsList;
      return urls[process.env.VUE_APP_WHERE].json;
    }
  },
  methods: {
    setNextPage(page) {
      this.component = page;
    },
    setAxios: function () {
      let website = this.$store.getters.getWebsite;
      let token = localStorage.getItem(website);
      if (token && token.length === 64) {
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        this.getUserInfo();
      }
      else {
        this.appReady = true;
      }
    },
    getQueryString: function () {
      let query = this.$route.query;
      if(query.tokenforgetpaswd && query.tokenforgetpaswd.length === 64) {
        //this.validateTokenForgetPassword(query.tokenforgetpaswd);
        this.validateTokenQueryString(query.tokenforgetpaswd, 'tokenforgetpaswd', "validateTokenForgetPassword", "PasswordChange");
      }
      else if(query.accountvalidation && query.accountvalidation.length === 64) {
        this.validateTokenQueryString(query.accountvalidation, 'accountvalidation', "validateTokenAccountValidation", "Login");
      }
      else if(query.NOCIE && query.NODIV) {
        this.validateBuildingUnit(query);
      }
      else if(query.PropertyCode && query.FloorPlan) {
        this.validateBuildingByFloorPlan(query.PropertyCode, query.FloorPlan);
      }
      else {
        this.setAxios();
      }
    },
    setLanguage: function () {
      let val = localStorage.getItem("application.cogir.net.language");
      if (val === 'en' || val === 'fr') {
        this.$i18n.locale = val;
      }
    },
    getUserInfo: function () {
      this.spinner = true;

      axios.post(this.url, {request: "getUserInfo" }, { headers: {'Content-Type': 'application/json'}})
            .then((response)  => {
                this.spinner = false;
                if (response.data.status === 0) {
                  this.$store.commit("addUser", response.data.user);
                  this.$store.commit("addBuildings", response.data.buildings);
                  this.$store.commit("addPublicUnits", response.data.publicUnits); 
                  let component = this.getComponent(response.data);
                  this.component = component;   
                  this.appReady = true;          
                }
            })
            .catch(()  => {
              let website = this.$store.getters.getWebsite;
              localStorage.removeItem(website);
              window.location.reload(true);
            });
    },
    getComponent: function (list) {
      let component = "ApplicationsProcess";
      if (list.endorserProcess.length > 0 && list.endorserProcess.length < 3) {
        component = "EndorserProcess";
      }
      return component;
    },
    validateTokenForgetPassword: function (token) {
      this.$router.replace({'tokenforgetpaswd': null});
      this.spinner = true;

      axios.post(this.url, {request: "validateTokenForgetPassword", token: token}, { headers: {'Content-Type': 'application/json'}})
            .then((response)  => {
                this.spinner = false;
                if (response.data.status === 0) {
                  this.$store.commit("addUser", response.data.user);
                  this.component = "PasswordChange";   
                  this.appReady = true;          
                }
                else {
                  this.component = "MessageCenter";   
                  this.$store.commit("addStatus", response.data.status);
                  this.appReady = true;
                }
            })
            .catch(()  => {
                this.error = this.$t('info.errorgeneric');
                this.spinner = false;
            });
    },
    validateTokenQueryString: function (token, key, request, component) {
      this.$router.replace({key: null});
      this.spinner = true;

      axios.post(this.url, {request: request, token: token}, { headers: {'Content-Type': 'application/json'}})
            .then((response)  => {
                this.spinner = false;
                if (response.data.status === 0) {
                  this.$store.commit("addUser", response.data.user);
                  if (key === "accountvalidation") {
                    this.$store.commit("setAccountActivatedStatus", true);
                  }
                  this.component = component;   
                  this.appReady = true;          
                }
                else {
                  this.component = "MessageCenter";   
                  this.$store.commit("addStatus", response.data.status);
                  this.appReady = true;
                }
            })
            .catch(()  => {
                this.error = this.$t('info.errorgeneric');
                this.spinner = false;
            });
    },
    validateBuildingByFloorPlan(PropertyCode, FloorPlan) {
      this.$router.replace({'PropertyCode': null});
      let pcl = this.acceptedPropertyCode;

      let obj = { propertyCode: PropertyCode, floorPlan: FloorPlan, unitAvail: 0 }

      if (pcl.includes(PropertyCode) && FloorPlan.length < 10) {    
        axios.post(this.url, {request: "validateUnitAvailableByPropertyCode", form: obj }, { headers: {'Content-Type': 'application/json'}})
            .then((response)  => {
                this.spinner = false;
                obj.unitAvail = response.data.status;
                obj.type = "floorPlan";
                if (response.data.status > 0) {               
                  localStorage.setItem("BuildingUnit", JSON.stringify(obj));      
                }
                this.$store.commit("addNoUnitAvailableFromQuery", obj);     
                this.setAxios();         
            })
            .catch(()  => {
              this.error = this.$t('info.errorgeneric');
              this.spinner = false;
            });
      }
      else {
        this.setAxios();  
      }

    },
    validateBuildingUnit: function (query) {
      
      this.$router.replace({'NOCIE': null});

      let pass = true;
      let NOCIE = parseInt(query.NOCIE);
      let NODIV = parseInt(query.NODIV);

      //if (NOCIE !== 899) { pass= false }
      if (isNaN(NODIV) || isNaN(NOCIE)) { pass = false }
      else {
        if (NODIV < 1 || NODIV > 100) { pass = false }
        if (NOCIE < 1 || NOCIE > 100) { pass = false }
      }

      if (pass) {
        let obj = {
          NOCIE: NOCIE,
          NODIV: NODIV,
          type:"building"
        }
        localStorage.setItem("BuildingUnit", JSON.stringify(obj));
        this.$store.commit("addNoUnitAvailableFromQuery", obj);     
      }
       this.setAxios();
    }
  },
  components: {
    Dispatcher,
    Header,
    Footer
  }
}
</script>
